import classNames from "classnames";
import React, { FC, memo } from "react";

import { Icon } from "@/eworkitComponents/components/Icon";
import { TStyleSize } from "@/eworkitComponents/components/Style";

import "./logo-placeholder.scss";

export interface ILogoPlaceholderProps {
  icon?: string;
  size?: TStyleSize;
  iconSize?: TStyleSize;
}

export const LogoPlaceholder: FC<ILogoPlaceholderProps> = memo(
  ({ icon = "company", size = "md", iconSize = "md", children }) => {
    const classes = classNames("logo-placeholder", `logo-placeholder--size-${size}`);

    return (
      <div className={classes}>
        <Icon icon={icon} size={iconSize} />
        {children}
      </div>
    );
  },
);
